var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"com-post-loading"},[_vm._v(" 加载中，莫慌莫慌~ ")])}
var staticRenderFns = []

export { render, staticRenderFns }